"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _construct2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/construct"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));
var _lodash = _interopRequireDefault(require("lodash"));
var _vue = _interopRequireDefault(require("vue"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var log = _Logger.default.namespace('ThemeManager');
var createdInstance = null;
var ThemeManager = /*#__PURE__*/function () {
  function ThemeManager(state, argTheme) {
    (0, _classCallCheck2.default)(this, ThemeManager);
    this.state = state;
    this.activeTheme = null;
    this.previousTheme = null;
    this.varsElement = null;
    this.currentElement = null;
    this.loadingElement = null;
    _vue.default.observable(this);
    var initialTheme = this.findTheme(argTheme) || this.findTheme(state.setting('theme')) || this.availableThemes()[0];
    this.setTheme(initialTheme);
  }
  (0, _createClass2.default)(ThemeManager, [{
    key: "availableThemes",
    value: function availableThemes() {
      return this.state.getSetting('settings.themes');
    }
  }, {
    key: "findTheme",
    value: function findTheme(name) {
      if (!name) {
        return null;
      }
      return (0, _find.default)(_lodash.default).call(_lodash.default, this.availableThemes(), function (t) {
        return t.name.toLowerCase() === name.toLowerCase();
      });
    }
  }, {
    key: "currentTheme",
    value: function currentTheme() {
      var theme = this.activeTheme || this.availableThemes()[0];
      return this.findTheme(theme.name);
    }
  }, {
    key: "setTheme",
    value: function setTheme(theme) {
      var _this = this;
      var nextTheme = (0, _assign.default)(Object.create(null), typeof theme === 'string' ? this.findTheme(theme) : theme);
      if (!nextTheme || !nextTheme.url) {
        // Tried to set an invalid theme, abort
        // reset the theme setting name to current if its not valid
        if (this.activeTheme.name !== this.state.setting('theme')) {
          this.state.setting('theme', this.activeTheme.name);
        }
        log.error('Invalid theme', nextTheme);
        return;
      }
      if (this.loadingElement) {
        // There is already a loading theme
        // remove it as we are about to load another
        document.head.removeChild(this.loadingElement);
        this.loadingElement = null;
      }
      if (this.activeTheme && this.activeTheme.url === nextTheme.url) {
        // Theme did not change, abort
        return;
      }
      var nextNameLower = nextTheme.name.toLowerCase();
      var themeElement = document.createElement('link');
      if (this.previousTheme) {
        // If previousTheme is not set then this is the initial theme
        // do not check its loading/error state so there is always an
        // active and previous theme set
        themeElement.onload = function () {
          // New theme loaded successfully
          _this.previousTheme = _this.activeTheme;
          _this.activeTheme = nextTheme;
          if (_this.currentElement) {
            // Remove the old theme from the DOM
            document.head.removeChild(_this.currentElement);
          }

          // Move our loaded element into current position
          _this.currentElement = _this.loadingElement;
          _this.loadingElement = null;
          if (nextTheme.name !== _this.state.setting('theme')) {
            // Reset the theme setting name to current if its not valid
            _this.state.setting('theme', nextTheme.name);
          }
          _this.state.$emit('theme.change', nextTheme, _this.previousTheme);
        };
        themeElement.onerror = function () {
          // New theme failed to load, remove its loading element
          document.head.removeChild(_this.loadingElement);
          _this.loadingElement = null;
          if (nextNameLower === 'custom' && !/\/theme\.css(\?|$)/.test(nextTheme.url)) {
            // For custom themes try appending /theme.css
            _this.setCustomThemeUrl(ThemeManager.themeUrl(nextTheme));
            return;
          }
          _this.state.$emit('theme.failed', nextTheme, _this.activeTheme);
        };
        this.loadingElement = themeElement;
      } else {
        // This is our initial theme set by url param or config
        this.activeTheme = nextTheme;
        this.previousTheme = nextTheme;
        this.currentElement = themeElement;
      }
      themeElement.rel = 'stylesheet';
      themeElement.type = 'text/css';
      themeElement.href = nextNameLower !== 'custom' ? ThemeManager.themeUrl(nextTheme) : nextTheme.url;
      document.head.appendChild(themeElement);
    }
  }, {
    key: "setCustomThemeUrl",
    value: function setCustomThemeUrl(url) {
      var theme = this.findTheme('custom');
      if (!theme) {
        return;
      }
      theme.url = url;
      this.setTheme(theme);
    }
  }, {
    key: "reload",
    value: function reload() {
      var theme = this.currentTheme();
      if (!theme) {
        return;
      }
      var url = theme.url;
      if (url.indexOf('cb=') > -1) {
        url = url.replace(/cb=[0-9]+/, function () {
          return 'cb=' + Date.now();
        });
      } else if (url.indexOf('?') > -1) {
        url += '&cb=' + Date.now();
      } else {
        url += '?cb=' + Date.now();
      }
      theme.url = url;
      this.setTheme(theme.name);
    }
  }, {
    key: "themeVar",
    value: function themeVar(varName) {
      var _context;
      if (!this.varsElement) {
        this.varsElement = document.querySelector('.kiwi-wrap');
      }
      var styles = window.getComputedStyle(this.varsElement);
      var value = styles.getPropertyValue('--kiwi-' + varName);
      return (0, _trim.default)(_context = value || '').call(_context);
    }
  }], [{
    key: "themeUrl",
    value: function themeUrl(theme) {
      var _theme$url$split = theme.url.split('?'),
        _theme$url$split2 = (0, _slicedToArray2.default)(_theme$url$split, 2),
        url = _theme$url$split2[0],
        qs = _theme$url$split2[1];
      if (url[url.length - 1] !== '/') {
        url += '/';
      }
      return url + 'theme.css' + (qs ? '?' + qs : '');
    }
  }]);
  return ThemeManager;
}();
exports.default = ThemeManager;
ThemeManager.instance = function () {
  if (!createdInstance) {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    createdInstance = (0, _construct2.default)(ThemeManager, args);
  }
  return createdInstance;
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ThemeManager"]
window._kiwi_exports.libs.ThemeManager = exports.default ? exports.default : exports;
